/**
 * 404 Not Found page.
 */

import { GlassCard } from "@/components/sc/glass-card";

export function NotFoundPage() {
  return (
    <GlassCard className="max-w-md mx-auto mt-12 text-center">
      <h2 className="text-h2 text-sc-navy font-display mb-2">
        Page Not Found
      </h2>
      <p className="text-body-sm text-sc-text-muted">
        The requested page does not exist. Check the URL or navigate using the
        sidebar.
      </p>
    </GlassCard>
  );
}
